// extracted by mini-css-extract-plugin
module.exports = {"legend":"legend-module__legend___3V_e4","icon":"legend-module__icon___I7lPh"};